var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"meeting-link text-larger",style:({
		color: _vm.color,
		backgroundColor: _vm.bgColor,
	}),attrs:{"href":_vm.videoUrl,"target":"_blank","rel":"noreferrer noopener"}},[_c('span',{staticClass:"meeting-link__text"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }